// extracted by mini-css-extract-plugin
export default {"p":"Pg_1_25_p__UsKmB"};